/**
 * ReDelivery v1
 * El delivery mas coopado
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { GroupItemsByCategoryDto } from '../model/groupItemsByCategoryDto';
import { ItemsCategoryInputDto } from '../model/itemsCategoryInputDto';
import { ItemsCategoryOutputDto } from '../model/itemsCategoryOutputDto';
import { ItemsCategoryUpdateDto } from '../model/itemsCategoryUpdateDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
    providedIn:'root'
})
export class ItemCategoryService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param cdItemCategory 
     * @param active 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiItemCategoryChangeStatePut(cdItemCategory?: number, active?: boolean, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public apiItemCategoryChangeStatePut(cdItemCategory?: number, active?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public apiItemCategoryChangeStatePut(cdItemCategory?: number, active?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public apiItemCategoryChangeStatePut(cdItemCategory?: number, active?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cdItemCategory !== undefined && cdItemCategory !== null) {
            queryParameters = queryParameters.set('cdItemCategory', <any>cdItemCategory);
        }
        if (active !== undefined && active !== null) {
            queryParameters = queryParameters.set('active', <any>active);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<boolean>('put',`${this.basePath}/api/ItemCategory/ChangeState`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdItemCategory 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiItemCategoryDeleteDelete(cdItemCategory?: number, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public apiItemCategoryDeleteDelete(cdItemCategory?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public apiItemCategoryDeleteDelete(cdItemCategory?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public apiItemCategoryDeleteDelete(cdItemCategory?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cdItemCategory !== undefined && cdItemCategory !== null) {
            queryParameters = queryParameters.set('cdItemCategory', <any>cdItemCategory);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<boolean>('delete',`${this.basePath}/api/ItemCategory/Delete`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiItemCategoryEditPut(body?: ItemsCategoryUpdateDto, observe?: 'body', reportProgress?: boolean): Observable<ItemsCategoryOutputDto>;
    public apiItemCategoryEditPut(body?: ItemsCategoryUpdateDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ItemsCategoryOutputDto>>;
    public apiItemCategoryEditPut(body?: ItemsCategoryUpdateDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ItemsCategoryOutputDto>>;
    public apiItemCategoryEditPut(body?: ItemsCategoryUpdateDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ItemsCategoryOutputDto>('put',`${this.basePath}/api/ItemCategory/Edit`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdStore 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiItemCategoryGetAllGet(cdStore: number, observe?: 'body', reportProgress?: boolean): Observable<Array<ItemsCategoryOutputDto>>;
    public apiItemCategoryGetAllGet(cdStore: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ItemsCategoryOutputDto>>>;
    public apiItemCategoryGetAllGet(cdStore: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ItemsCategoryOutputDto>>>;
    public apiItemCategoryGetAllGet(cdStore: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (cdStore === null || cdStore === undefined) {
            throw new Error('Required parameter cdStore was null or undefined when calling apiItemCategoryGetAllGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cdStore !== undefined && cdStore !== null) {
            queryParameters = queryParameters.set('cdStore', <any>cdStore);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ItemsCategoryOutputDto>>('get',`${this.basePath}/api/ItemCategory/GetAll`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdCategory 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiItemCategoryGetOneGet(cdCategory?: number, observe?: 'body', reportProgress?: boolean): Observable<ItemsCategoryOutputDto>;
    public apiItemCategoryGetOneGet(cdCategory?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ItemsCategoryOutputDto>>;
    public apiItemCategoryGetOneGet(cdCategory?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ItemsCategoryOutputDto>>;
    public apiItemCategoryGetOneGet(cdCategory?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cdCategory !== undefined && cdCategory !== null) {
            queryParameters = queryParameters.set('cdCategory', <any>cdCategory);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ItemsCategoryOutputDto>('get',`${this.basePath}/api/ItemCategory/GetOne`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdStore 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiItemCategoryGroupItemsByCategoryGet(cdStore?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<GroupItemsByCategoryDto>>;
    public apiItemCategoryGroupItemsByCategoryGet(cdStore?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<GroupItemsByCategoryDto>>>;
    public apiItemCategoryGroupItemsByCategoryGet(cdStore?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<GroupItemsByCategoryDto>>>;
    public apiItemCategoryGroupItemsByCategoryGet(cdStore?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cdStore !== undefined && cdStore !== null) {
            queryParameters = queryParameters.set('cdStore', <any>cdStore);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<GroupItemsByCategoryDto>>('get',`${this.basePath}/api/ItemCategory/GroupItemsByCategory`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiItemCategoryPostPost(body?: ItemsCategoryInputDto, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public apiItemCategoryPostPost(body?: ItemsCategoryInputDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public apiItemCategoryPostPost(body?: ItemsCategoryInputDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public apiItemCategoryPostPost(body?: ItemsCategoryInputDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<number>('post',`${this.basePath}/api/ItemCategory/Post`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
